/**
 * True when the user has requested reduced motion at the OS/browser level
 * (`prefers-reduced-motion: reduce`). Safe to call outside the browser
 * (SSR/tests) — returns false when `window.matchMedia` isn't available.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/**
 * `Element.scrollIntoView` that respects the user's reduced-motion
 * preference: falls back to an instant jump instead of an animated smooth
 * scroll so it doesn't fight `prefers-reduced-motion: reduce`.
 */
export function scrollIntoViewWithMotionPreference(
  element: Element,
  options?: ScrollIntoViewOptions
): void {
  element.scrollIntoView({
    ...options,
    behavior: prefersReducedMotion() ? 'auto' : (options?.behavior ?? 'smooth'),
  });
}
